module.exports = __webpack_public_path__ + "static/img/cherry_t.43736331.png";